// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   Survey Connect — Premium Fintech Animation System
   ═══════════════════════════════════════════════════════════════ */

/* ─── Core Keyframes ──────────────────────────────────────────── */

@keyframes sc-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes sc-fade-in-up {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes sc-fade-in-down {
  from { opacity: 0; transform: translateY(-16px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes sc-slide-up {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes sc-slide-down {
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
}

@keyframes sc-slide-in-right {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes sc-slide-in-left {
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes sc-scale-in {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes sc-scale-bounce {
  0% { transform: scale(0.85); opacity: 0; }
  60% { transform: scale(1.04); opacity: 1; }
  100% { transform: scale(1); }
}

@keyframes sc-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

@keyframes sc-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes sc-spin {
  to { transform: rotate(360deg); }
}

@keyframes sc-ping {
  75%, 100% { transform: scale(2); opacity: 0; }
}

@keyframes sc-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

@keyframes sc-shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
}

@keyframes sc-progress-indeterminate {
  0% { transform: translateX(-100%); }
  50% { transform: translateX(0%); }
  100% { transform: translateX(100%); }
}

/* Bottom sheet entrance */
@keyframes sc-sheet-up {
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Toast entrance */
@keyframes sc-toast-in {
  from { transform: translateY(-20px) scale(0.95); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

@keyframes sc-toast-out {
  from { transform: translateY(0) scale(1); opacity: 1; }
  to { transform: translateY(-20px) scale(0.95); opacity: 0; }
}

/* Success check animation */
@keyframes sc-check-draw {
  0% { stroke-dashoffset: 50; }
  100% { stroke-dashoffset: 0; }
}

@keyframes sc-circle-draw {
  0% { stroke-dashoffset: 166; }
  100% { stroke-dashoffset: 0; }
}

/* ─── Animation Utility Classes ───────────────────────────────── */

.sc-animate-fade-in {
  animation: sc-fade-in 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.sc-animate-fade-in-up {
  animation: sc-fade-in-up 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.sc-animate-fade-in-down {
  animation: sc-fade-in-down 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.sc-animate-slide-up {
  animation: sc-slide-up 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.sc-animate-scale-in {
  animation: sc-scale-in 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.sc-animate-scale-bounce {
  animation: sc-scale-bounce 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.sc-animate-shimmer {
  background: linear-gradient(90deg, 
    var(--sc-bg-skeleton) 25%, 
    rgba(255,255,255,0.15) 50%, 
    var(--sc-bg-skeleton) 75%
  );
  background-size: 200% 100%;
  animation: sc-shimmer 1.5s ease-in-out infinite;
}

.sc-animate-pulse {
  animation: sc-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.sc-animate-spin {
  animation: sc-spin 0.8s linear infinite;
}

.sc-animate-bounce {
  animation: sc-bounce 1s ease infinite;
}

.sc-animate-sheet {
  animation: sc-sheet-up 0.35s cubic-bezier(0.32, 0.72, 0, 1) forwards;
}

.sc-animate-toast-in {
  animation: sc-toast-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.sc-animate-toast-out {
  animation: sc-toast-out 0.25s cubic-bezier(0.4, 0, 1, 1) forwards;
}

/* ─── Stagger Delay Utilities ─────────────────────────────────── */

.sc-stagger-1 { animation-delay: 0.05s; }
.sc-stagger-2 { animation-delay: 0.1s; }
.sc-stagger-3 { animation-delay: 0.15s; }
.sc-stagger-4 { animation-delay: 0.2s; }
.sc-stagger-5 { animation-delay: 0.25s; }
.sc-stagger-6 { animation-delay: 0.3s; }
.sc-stagger-7 { animation-delay: 0.35s; }
.sc-stagger-8 { animation-delay: 0.4s; }

/* ─── Transition Utilities ────────────────────────────────────── */

.sc-transition-all {
  transition: all var(--sc-transition-base);
}

.sc-transition-fast {
  transition: all var(--sc-transition-fast);
}

.sc-transition-slow {
  transition: all var(--sc-transition-slow);
}

.sc-transition-colors {
  transition: color var(--sc-transition-fast), 
              background-color var(--sc-transition-fast),
              border-color var(--sc-transition-fast);
}

.sc-transition-transform {
  transition: transform var(--sc-transition-base);
}

/* ─── Interactive States ──────────────────────────────────────── */

.sc-hover-lift {
  transition: transform var(--sc-transition-base), box-shadow var(--sc-transition-base);
}
.sc-hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: var(--sc-shadow-lg);
}
.sc-hover-lift:active {
  transform: translateY(0);
}

.sc-hover-scale {
  transition: transform var(--sc-transition-fast);
}
.sc-hover-scale:hover {
  transform: scale(1.03);
}
.sc-hover-scale:active {
  transform: scale(0.97);
}

.sc-press {
  transition: transform var(--sc-transition-fast), opacity var(--sc-transition-fast);
}
.sc-press:active {
  transform: scale(0.96);
  opacity: 0.85;
}

/* ─── Mobile-Specific ─────────────────────────────────────────── */

/* Tap highlight removal */
.sc-no-tap-highlight {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
}

/* Safe area padding */
.sc-safe-bottom {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.sc-safe-top {
  padding-top: env(safe-area-inset-top, 0px);
}

/* ─── Page Transitions ────────────────────────────────────────── */

.sc-page-enter {
  opacity: 0;
  transform: translateY(8px);
}

.sc-page-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ─── Skeleton Placeholders ───────────────────────────────────── */

.sc-skeleton {
  background: linear-gradient(90deg, 
    var(--sc-bg-skeleton, #E2E8F0) 25%, 
    rgba(255,255,255,0.2) 50%, 
    var(--sc-bg-skeleton, #E2E8F0) 75%
  );
  background-size: 200% 100%;
  animation: sc-shimmer 1.5s ease-in-out infinite;
  border-radius: var(--sc-radius-sm, 8px);
}

.sc-skeleton-text {
  height: 14px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.sc-skeleton-title {
  height: 22px;
  width: 60%;
  border-radius: 6px;
  margin-bottom: 12px;
}

.sc-skeleton-circle {
  border-radius: 50%;
}

.sc-skeleton-card {
  height: 80px;
  border-radius: var(--sc-radius-lg, 16px);
  margin-bottom: 12px;
}

/* ─── Reduced Motion ──────────────────────────────────────────── */

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/animations.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE,oEAAoE;;AAEpE;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,KAAK,sBAAsB,EAAE,UAAU,EAAE;EACzC,MAAM,sBAAsB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY,mBAAmB,EAAE,UAAU,EAAE;AAC/C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,MAAM,yBAAyB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,0BAA0B;AAC1B;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,mBAAmB;AACnB;EACE,OAAO,wCAAwC,EAAE,UAAU,EAAE;EAC7D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,OAAO,iCAAiC,EAAE,UAAU,EAAE;EACtD,KAAK,wCAAwC,EAAE,UAAU,EAAE;AAC7D;;AAEA,4BAA4B;AAC5B;EACE,KAAK,qBAAqB,EAAE;EAC5B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA;EACE,KAAK,sBAAsB,EAAE;EAC7B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA,oEAAoE;;AAEpE;EACE,gEAAgE;AAClE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE;;;;GAIC;EACD,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,iEAAiE;AACnE;;AAEA,oEAAoE;;AAEpE,gBAAgB,sBAAsB,EAAE;AACxC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,sBAAsB,EAAE;AACxC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,sBAAsB,EAAE;AACxC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,sBAAsB,EAAE;AACxC,gBAAgB,qBAAqB,EAAE;;AAEvC,oEAAoE;;AAEpE;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;;oDAEkD;AACpD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,oEAAoE;;AAEpE;EACE,qFAAqF;AACvF;AACA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,kFAAkF;AACpF;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA,oEAAoE;;AAEpE,0BAA0B;AAC1B;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oEAAoE;;AAEpE;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB;yDACuD;AACzD;;AAEA,oEAAoE;;AAEpE;EACE;;;;GAIC;EACD,0BAA0B;EAC1B,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,oEAAoE;;AAEpE;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   Survey Connect — Premium Fintech Animation System\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ─── Core Keyframes ──────────────────────────────────────────── */\n\n@keyframes sc-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes sc-fade-in-up {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes sc-fade-in-down {\n  from { opacity: 0; transform: translateY(-16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes sc-slide-up {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n@keyframes sc-slide-down {\n  from { transform: translateY(-100%); }\n  to { transform: translateY(0); }\n}\n\n@keyframes sc-slide-in-right {\n  from { transform: translateX(100%); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n@keyframes sc-slide-in-left {\n  from { transform: translateX(-100%); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n@keyframes sc-scale-in {\n  from { opacity: 0; transform: scale(0.92); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n@keyframes sc-scale-bounce {\n  0% { transform: scale(0.85); opacity: 0; }\n  60% { transform: scale(1.04); opacity: 1; }\n  100% { transform: scale(1); }\n}\n\n@keyframes sc-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n@keyframes sc-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n@keyframes sc-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes sc-ping {\n  75%, 100% { transform: scale(2); opacity: 0; }\n}\n\n@keyframes sc-bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-6px); }\n}\n\n@keyframes sc-shake {\n  0%, 100% { transform: translateX(0); }\n  20%, 60% { transform: translateX(-4px); }\n  40%, 80% { transform: translateX(4px); }\n}\n\n@keyframes sc-progress-indeterminate {\n  0% { transform: translateX(-100%); }\n  50% { transform: translateX(0%); }\n  100% { transform: translateX(100%); }\n}\n\n/* Bottom sheet entrance */\n@keyframes sc-sheet-up {\n  from { transform: translateY(100%); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* Toast entrance */\n@keyframes sc-toast-in {\n  from { transform: translateY(-20px) scale(0.95); opacity: 0; }\n  to { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n@keyframes sc-toast-out {\n  from { transform: translateY(0) scale(1); opacity: 1; }\n  to { transform: translateY(-20px) scale(0.95); opacity: 0; }\n}\n\n/* Success check animation */\n@keyframes sc-check-draw {\n  0% { stroke-dashoffset: 50; }\n  100% { stroke-dashoffset: 0; }\n}\n\n@keyframes sc-circle-draw {\n  0% { stroke-dashoffset: 166; }\n  100% { stroke-dashoffset: 0; }\n}\n\n/* ─── Animation Utility Classes ───────────────────────────────── */\n\n.sc-animate-fade-in {\n  animation: sc-fade-in 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n.sc-animate-fade-in-up {\n  animation: sc-fade-in-up 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n.sc-animate-fade-in-down {\n  animation: sc-fade-in-down 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n.sc-animate-slide-up {\n  animation: sc-slide-up 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n.sc-animate-scale-in {\n  animation: sc-scale-in 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n.sc-animate-scale-bounce {\n  animation: sc-scale-bounce 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.sc-animate-shimmer {\n  background: linear-gradient(90deg, \n    var(--sc-bg-skeleton) 25%, \n    rgba(255,255,255,0.15) 50%, \n    var(--sc-bg-skeleton) 75%\n  );\n  background-size: 200% 100%;\n  animation: sc-shimmer 1.5s ease-in-out infinite;\n}\n\n.sc-animate-pulse {\n  animation: sc-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.sc-animate-spin {\n  animation: sc-spin 0.8s linear infinite;\n}\n\n.sc-animate-bounce {\n  animation: sc-bounce 1s ease infinite;\n}\n\n.sc-animate-sheet {\n  animation: sc-sheet-up 0.35s cubic-bezier(0.32, 0.72, 0, 1) forwards;\n}\n\n.sc-animate-toast-in {\n  animation: sc-toast-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.sc-animate-toast-out {\n  animation: sc-toast-out 0.25s cubic-bezier(0.4, 0, 1, 1) forwards;\n}\n\n/* ─── Stagger Delay Utilities ─────────────────────────────────── */\n\n.sc-stagger-1 { animation-delay: 0.05s; }\n.sc-stagger-2 { animation-delay: 0.1s; }\n.sc-stagger-3 { animation-delay: 0.15s; }\n.sc-stagger-4 { animation-delay: 0.2s; }\n.sc-stagger-5 { animation-delay: 0.25s; }\n.sc-stagger-6 { animation-delay: 0.3s; }\n.sc-stagger-7 { animation-delay: 0.35s; }\n.sc-stagger-8 { animation-delay: 0.4s; }\n\n/* ─── Transition Utilities ────────────────────────────────────── */\n\n.sc-transition-all {\n  transition: all var(--sc-transition-base);\n}\n\n.sc-transition-fast {\n  transition: all var(--sc-transition-fast);\n}\n\n.sc-transition-slow {\n  transition: all var(--sc-transition-slow);\n}\n\n.sc-transition-colors {\n  transition: color var(--sc-transition-fast), \n              background-color var(--sc-transition-fast),\n              border-color var(--sc-transition-fast);\n}\n\n.sc-transition-transform {\n  transition: transform var(--sc-transition-base);\n}\n\n/* ─── Interactive States ──────────────────────────────────────── */\n\n.sc-hover-lift {\n  transition: transform var(--sc-transition-base), box-shadow var(--sc-transition-base);\n}\n.sc-hover-lift:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--sc-shadow-lg);\n}\n.sc-hover-lift:active {\n  transform: translateY(0);\n}\n\n.sc-hover-scale {\n  transition: transform var(--sc-transition-fast);\n}\n.sc-hover-scale:hover {\n  transform: scale(1.03);\n}\n.sc-hover-scale:active {\n  transform: scale(0.97);\n}\n\n.sc-press {\n  transition: transform var(--sc-transition-fast), opacity var(--sc-transition-fast);\n}\n.sc-press:active {\n  transform: scale(0.96);\n  opacity: 0.85;\n}\n\n/* ─── Mobile-Specific ─────────────────────────────────────────── */\n\n/* Tap highlight removal */\n.sc-no-tap-highlight {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n\n/* Safe area padding */\n.sc-safe-bottom {\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n.sc-safe-top {\n  padding-top: env(safe-area-inset-top, 0px);\n}\n\n/* ─── Page Transitions ────────────────────────────────────────── */\n\n.sc-page-enter {\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n.sc-page-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ─── Skeleton Placeholders ───────────────────────────────────── */\n\n.sc-skeleton {\n  background: linear-gradient(90deg, \n    var(--sc-bg-skeleton, #E2E8F0) 25%, \n    rgba(255,255,255,0.2) 50%, \n    var(--sc-bg-skeleton, #E2E8F0) 75%\n  );\n  background-size: 200% 100%;\n  animation: sc-shimmer 1.5s ease-in-out infinite;\n  border-radius: var(--sc-radius-sm, 8px);\n}\n\n.sc-skeleton-text {\n  height: 14px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.sc-skeleton-title {\n  height: 22px;\n  width: 60%;\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.sc-skeleton-circle {\n  border-radius: 50%;\n}\n\n.sc-skeleton-card {\n  height: 80px;\n  border-radius: var(--sc-radius-lg, 16px);\n  margin-bottom: 12px;\n}\n\n/* ─── Reduced Motion ──────────────────────────────────────────── */\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
